import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import Dropdown from "../../primitives/Dropdown";
import { ENRICHMENT_CATEGORIES } from "../constants";

/**
 * Modal for adding default values to array fields
 */
const AddDefaultModal = ({ open, onClose, onSubmit, modalState, onStateChange }) => {
  const { arrayField, value, granted, category, enrichmentType, commPreferenceType } = modalState;

  const categoryOptions = Object.keys(ENRICHMENT_CATEGORIES);
  const safeCategory = categoryOptions.includes(category) ? category : "";
  const availableTypes = safeCategory ? ENRICHMENT_CATEGORIES[safeCategory] || [] : [];
  const safeEnrichmentType = availableTypes.includes(enrichmentType) ? enrichmentType : "";

  const handleSubmit = () => {
    if (value.trim()) {
      onSubmit();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Default {arrayField.slice(0, -1)}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={`${arrayField.slice(0, -1)} Value`}
          fullWidth
          variant="outlined"
          value={value}
          onChange={(e) => onStateChange("value", e.target.value)}
          sx={{ mb: 2 }}
        />
        {arrayField === "commPreferences" && (
          <TextField
            margin="dense"
            label="Communication Preference Type"
            fullWidth
            variant="outlined"
            value={commPreferenceType}
            onChange={(e) => onStateChange("commPreferenceType", e.target.value)}
            placeholder="marketing"
            helperText="Enter the communication preference type (e.g., marketing, promotional, newsletter)"
            sx={{ mb: 2 }}
          />
        )}
        {arrayField === "enrichmentData" && (
          <>
            <Dropdown
              label="Category"
              id="default-enrichment-category"
              name="category"
              value={safeCategory}
              onChange={(e) => onStateChange("category", e.target.value)}
              options={categoryOptions}
            />
            <Dropdown
              label="Enrichment Type"
              id="default-enrichment-type"
              name="enrichmentType"
              value={safeEnrichmentType}
              onChange={(e) => onStateChange("enrichmentType", e.target.value)}
              options={availableTypes}
              disabled={!safeCategory}
            />
          </>
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={granted}
              onChange={(e) => onStateChange("granted", e.target.checked)}
            />
          }
          label="Granted"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDefaultModal;
